import * as type from './types';

export function getCustomerReviews(data) {
    return {
        type: type.GET_CUSTOMER_REVIEWS_REQUESTED,
        data: data,
    }
}